import { forwardRef } from 'react';
import { v4 as uuid } from 'uuid';

import SvgIcon from 'shell/components/SvgIcon';

export default forwardRef((props, ref) => {
    const id = uuid();

    return (
        <SvgIcon ref={ref} {...props}>
            <g clipPath={`url(#${id})`}>
                <path d='M24 0C24 7.56 24 11.784 24 19.2H21.6V2.4H4.8V0C11.712 0 14.58 0 24 0ZM0 4.8C3.816 4.8 15.048 4.8 19.2 4.8C19.2 8.676 19.2 20.136 19.2 24C15.384 24 4.152 24 0 24C0 16.908 0 11.868 0 4.8ZM15.108 21.6L11.628 18.12L8.148 21.6H15.108ZM2.4 12.204L4.296 10.308L4.32 10.332L4.344 10.308L9.9 15.864L11.616 14.148L11.64 14.172L11.664 14.148L16.824 19.308V7.2H2.424V12.204H2.4ZM2.4 21.6H4.752L8.196 17.856L4.32 13.68L2.4 15.6V21.6ZM13.296 12.804C14.616 12.804 15.696 11.724 15.696 10.404C15.696 9.084 14.616 8.004 13.296 8.004C11.976 8.004 10.896 9.084 10.896 10.404C10.896 11.724 11.976 12.804 13.296 12.804Z' />
            </g>
            <defs>
                <clipPath id={id}>
                    <rect width='24' height='24' />
                </clipPath>
            </defs>
        </SvgIcon>
    );
});
